//
import PermissionModel from "@/models/Permission"

//
import { required } from "@/services/validations"
import headers from "./headers"

//
export default [
    {
        name: "name",
        type: "text-field",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: "Nombre",
            rules: [ required ],
        },
    },
    {
        name: "role_name",
        type: "text-field",
        flex: {
            sm6: true,
        },
        props: {
            label: "Nombre para mostrar",
            rules: [ required ],
        },
    },
    {
        name: "selected_permissions",
        type: "data-table-model",
        flex: {
            "pt-0": true,
            "xs12": true,
            "d-grid": true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers,
            noActions: true,
            noDataText: "Sin permisos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            pickerProps: {
                filters: [],
                headers,
                noPagination: false,
                paramSearch: "name",
                submitText: "confirmar selección",
                service: PermissionModel,
            },
            rules: [ required ],
            showNativePagination: true,
            showPicker: true,
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
            toolbarTitle: "Lista de permisos asignados al rol",
        },
    },
]